import { Component, OnDestroy, OnInit } from "@angular/core";
import { EmitterService } from "src/app/EmitterService";


@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
    currentYear: any;
    subscription: any;
    mainData: any;
    loadingData = true;
    Qlinks: any;
    Ilinks: any;
    siteAuthor: any;

    constructor(private emitterService: EmitterService)
    {

    }

    ngOnInit()
    {
        this.currentYear = new Date().getFullYear();
        this.subscription = this.emitterService.currentMessage.subscribe(
            (message) =>
            {
                if (message === true)
                {
                    let mData = localStorage.getItem('mainData');
                    this.mainData = JSON.parse(mData);

                    if (mData != null)
                    {
                        this.mainData = JSON.parse(mData);
                        this.Qlinks = this.mainData.Links.filter(x => x.Type == "1");
                        this.Ilinks = this.mainData.Links.filter(x => x.Type == "2");
                    //    console.log(this.Qlinks, "fuuuuu");
                       
                            let SiteAuthor = this.mainData.LocalOptions.filter(x => x.KeyName == "SiteAuthor");
                            console.log(SiteAuthor, "hhhhhhhh" );
                            this.siteAuthor = SiteAuthor[0].KeyValue;
                        this.loadingData = false;
                    
                       
                    }
                }
            }
        );
        
    }
        ngOnDestroy()
        {
            this.subscription.unsubscribe();
        }
        
    }
    
